import { render } from "./LayoutSidebarContainer.vue?vue&type=template&id=4a87f136"
const script = {}

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__